/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionRecordState } from './submissionRecordState';
import type { SubmissionRecordSubmissionDate } from './submissionRecordSubmissionDate';
import type { SubmissionRecordCorrectionDate } from './submissionRecordCorrectionDate';
import type { SubmissionRecordCorrectionDuedate } from './submissionRecordCorrectionDuedate';
import type { SubmissionRecordStudent } from './submissionRecordStudent';
import type { SubmissionRecordCorrector } from './submissionRecordCorrector';
import type { ReportIdTitleReference } from './reportIdTitleReference';
import type { SubmissionRecordGrading } from './submissionRecordGrading';
import type { SubmissionRecordExamAttemptsUsed } from './submissionRecordExamAttemptsUsed';
import type { SubmissionRecordExamAttemptsAllowed } from './submissionRecordExamAttemptsAllowed';
import type { SubmissionRecordExamNextAction } from './submissionRecordExamNextAction';
import type { SubmissionRecordAttemptNumber } from './submissionRecordAttemptNumber';
import type { SubmissionRecordEtag } from './submissionRecordEtag';

/**
 * Info about a submission for reporting
 */
export interface SubmissionRecord {
  state?: SubmissionRecordState;
  submissionDate?: SubmissionRecordSubmissionDate;
  correctionDate?: SubmissionRecordCorrectionDate;
  correctionDuedate?: SubmissionRecordCorrectionDuedate;
  student: SubmissionRecordStudent;
  corrector?: SubmissionRecordCorrector;
  course: ReportIdTitleReference;
  module: ReportIdTitleReference;
  grading?: SubmissionRecordGrading;
  examAttemptsUsed?: SubmissionRecordExamAttemptsUsed;
  examAttemptsAllowed?: SubmissionRecordExamAttemptsAllowed;
  examNextAction?: SubmissionRecordExamNextAction;
  attemptNumber?: SubmissionRecordAttemptNumber;
  etag?: SubmissionRecordEtag;
}
